import { render, staticRenderFns } from "./legalDeliveryScale.vue?vue&type=template&id=2d2c73fc&scoped=true&"
import script from "./legalDeliveryScale.vue?vue&type=script&lang=ts&"
export * from "./legalDeliveryScale.vue?vue&type=script&lang=ts&"
import style0 from "./legalDeliveryScale.vue?vue&type=style&index=0&id=2d2c73fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c73fc",
  null
  
)

export default component.exports